<template>
  <b-card body-class="p-0" header-class="bg-gradient-warning border-0 shadow" class="table-card">
    <template v-slot:header>
      <b-row align-v="center">
        <b-col>
          <h3 class="mb-0 text-white">
            <i class="ni ni-chart-bar-32 mr-2"></i>Traffic Sources
          </h3>
          <p class="text-white-50 mb-0 small description-referral">Referral analytics and engagement</p>
        </b-col>
        <b-col class="text-right">
          <b-button size="sm" variant="light" class="shadow-sm">
            <i class="ni ni-bold-right mr-1"></i>View Report
          </b-button>
        </b-col>
      </b-row>
    </template>

    <div class="table-container">
      <el-table
        class="table-responsive table table-hover"
        :data="tableData"
        header-row-class-name="thead-light"
        :row-class-name="tableRowClassName">
        <el-table-column label="Source" min-width="140px" prop="name">
          <template v-slot="{row}">
            <div class="d-flex align-items-center">
              <div class="source-icon mr-3" :class="getSourceIconClass(row.name)">
                <i :class="getSourceIcon(row.name)" class="text-white"></i>
              </div>
              <div>
                <div class="font-weight-600 text-dark">{{row.name}}</div>
                <small class="text-muted">Social platform</small>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Visitors" min-width="120px" prop="visitors">
          <template v-slot="{row}">
            <div class="d-flex align-items-center">
              <span class="font-weight-600 mr-2">{{row.visitors}}</span>
              <small class="text-success">
                <i class="ni ni-bold-up"></i> +12%
              </small>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Engagement" min-width="200px" prop="progress">
          <template v-slot="{row}">
            <div class="d-flex align-items-center">
              <div class="progress-info mr-3">
                <span class="font-weight-600">{{row.progress}}%</span>
                <small class="text-muted d-block">Conversion</small>
              </div>
              <div class="flex-fill">
                <b-progress :value="row.progress" height="8px" :variant="getProgressVariant(row.progress)">
                  <b-progress-bar :value="row.progress" :variant="getProgressVariant(row.progress)">
                  </b-progress-bar>
                </b-progress>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </b-card>
</template>
<script>
  import { BaseProgress } from '@/components';
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui';
  import BaseButton from '../../BaseButton.vue';
  export default {
    name: 'social-traffic-table',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    data() {
      return {
        tableData: [
          {
            name: 'Facebook',
            visitors: '1,480',
            progress: 60,
          },
          {
            name: 'LinkedIn',
            visitors: '5,480',
            progress: 70,
          },
          {
            name: 'Google',
            visitors: '4,807',
            progress: 80,
          },
          {
            name: 'Instagram',
            visitors: '3,678',
            progress: 75,
          },
          {
            name: 'Twitter',
            visitors: '2,645',
            progress: 30,
          }
        ]
      }
    },
    methods: {
      tableRowClassName({ row, rowIndex }) {
        return rowIndex % 2 === 0 ? 'table-row-even' : 'table-row-odd';
      },
      getSourceIcon(platform) {
        const icons = {
          'Facebook': 'fab fa-facebook-f',
          'LinkedIn': 'fab fa-linkedin-in',
          'Google': 'fab fa-google',
          'Instagram': 'fab fa-instagram',
          'Twitter': 'fab fa-twitter'
        };
        return icons[platform] || 'ni ni-world';
      },
      getSourceIconClass(platform) {
        const classes = {
          'Facebook': 'facebook-bg',
          'LinkedIn': 'linkedin-bg',
          'Google': 'google-bg',
          'Instagram': 'instagram-bg',
          'Twitter': 'twitter-bg'
        };
        return classes[platform] || 'default-bg';
      },
      getProgressVariant(progress) {
        if (progress >= 80) return 'success';
        if (progress >= 60) return 'primary';
        if (progress >= 40) return 'warning';
        return 'danger';
      }
    }

  }
</script>
<style scoped>
.table-card {
  border-radius: 12px !important;
  overflow: hidden;
  transition: all 0.3s ease;
}

.table-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1) !important;
}

.table-container {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0 0 12px 12px;
  padding: 0;
}

.source-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

/* Social media brand colors */
.facebook-bg { background: linear-gradient(135deg, #4267B2, #365899); }
.linkedin-bg { background: linear-gradient(135deg, #0077B5, #005885); }
.google-bg { background: linear-gradient(135deg, #DB4437, #C23321); }
.instagram-bg { background: linear-gradient(135deg, #E4405F, #D81B60); }
.twitter-bg { background: linear-gradient(135deg, #1DA1F2, #0D95E8); }
.default-bg { background: linear-gradient(135deg, #5e72e4, #4c63d2); }

.table-row-even {
  background-color: rgba(0, 0, 0, 0.02);
}

.table-row-odd {
  background-color: rgba(255, 255, 255, 0.8);
}

.table-hover tbody tr:hover {
  background-color: rgba(245, 166, 35, 0.05) !important;
  transform: scale(1.01);
  transition: all 0.2s ease;
}

.progress-info {
  min-width: 60px;
}

.description-referral {
  line-height: normal;
  font-size: 1rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .table-card:hover {
    transform: none;
  }

  .table-hover tbody tr:hover {
    transform: none;
  }

  .source-icon {
    width: 35px;
    height: 35px;
    font-size: 14px;
  }

  .progress-info {
    min-width: 50px;
  }
}
</style>
